export { CoupeCarIcon } from './car-shape-coupe'
